<div class="phone-toggle-container" data-testid="phone-toggle">
  <button 
    (click)="onPhoneClick()"
    askButton size="mini" 
    class="webphone-action" 
    [ngClass]="'-' + currentPhoneStatus"
    data-testid="phone-button"
  >
    <span class="material-icons notranslate icon" *ngIf="!isLoading" data-testid="phone-icon">phone</span>
    <span
      *ngIf="isLoading"
      class="loading"
      [askSpinner]="isLoading"
      spinnerSize="small"
      spinnerColor="var(--color-texticon-contrast)"
      data-testid="phone-loading"
    ></span>

    <span class="label" data-testid="phone-label">{{ buttonLabel | translate }}</span>
  </button>
  
</div>